module.exports = __webpack_public_path__ + "img/20200406_152518.1100be9d.jpg";